export default {
    title: 'Nutzer erstellen',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    organisation: 'Organisation',
    role: 'Rolle',
    createHelpText: 'Der Nutzer wird mit einem zufällig generierten Passwort angelegt. Dieses kann über die "Passwort zurücksetzen" Funktion geändert werden.',

    createUser: 'Nutzer erstellen',
    createAndEditUser: 'Erstellen und weiter bearbeiten',
    createUserSuccess: 'Der Nutzer wurde erfolgreich erstellt.',
    createUserError: 'Der Nutzer konnte nicht erstellt werden.',

    mailAlreadyExists: 'Diese E-Mail-Adresse ist bereits in einer anderen Organisation registriert.',
    connectExistingUser: 'Soll der bestehende Nutzer dieser Organisation mit der Rolle {role} hinzugefügt werden?',
    saveOrganisationUser: 'Nutzer verknüpfen',

    connectUserSuccess: 'Der Nutzer wurde erfolgreich verknüpft.',
    connectUserError: 'Der Nutzer konnte nicht verknüpft werden.',
}